import { useNavigate } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import SEOHead from '../../../components/SEOHead';

export default function GradesHubPage() {
  const navigate = useNavigate();
  const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'K-12 Mathematics Courses by Augustine Anyimadu-Ahenkae',
    description: 'Complete K-12 mathematics curriculum covering Kindergarten through Grade 12, AP Calculus, AP Statistics, and Precalculus.',
    url: `${siteUrl}/grades`,
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Kindergarten Math', url: `${siteUrl}/grades/kindergarten` },
      { '@type': 'ListItem', position: 2, name: 'Grade 1 Math', url: `${siteUrl}/grades/grade-1` },
      { '@type': 'ListItem', position: 3, name: 'Grade 2 Math', url: `${siteUrl}/grades/grade-2` },
      { '@type': 'ListItem', position: 4, name: 'Grade 3 Math', url: `${siteUrl}/grades/grade-3` },
      { '@type': 'ListItem', position: 5, name: 'Grade 4 Math', url: `${siteUrl}/grades/grade-4` },
      { '@type': 'ListItem', position: 6, name: 'Grade 5 Math', url: `${siteUrl}/grades/grade-5` },
      { '@type': 'ListItem', position: 7, name: 'Grade 6 Math', url: `${siteUrl}/grades/grade-6` },
      { '@type': 'ListItem', position: 8, name: 'Grade 7 Math', url: `${siteUrl}/grades/grade-7` },
      { '@type': 'ListItem', position: 9, name: 'Grade 8 Math', url: `${siteUrl}/grades/grade-8` },
      { '@type': 'ListItem', position: 10, name: 'Grade 9 Algebra I', url: `${siteUrl}/grades/grade-9` },
      { '@type': 'ListItem', position: 11, name: 'Grade 10 Geometry', url: `${siteUrl}/grades/grade-10` },
      { '@type': 'ListItem', position: 12, name: 'Grade 11 Algebra II & Trig', url: `${siteUrl}/grades/grade-11` },
      { '@type': 'ListItem', position: 13, name: 'Grade 12 Precalculus', url: `${siteUrl}/grades/grade-12` },
      { '@type': 'ListItem', position: 14, name: 'AP Calculus AB', url: `${siteUrl}/grades/ap-calculus-ab` },
      { '@type': 'ListItem', position: 15, name: 'AP Calculus BC', url: `${siteUrl}/grades/ap-calculus-bc` },
      { '@type': 'ListItem', position: 16, name: 'AP Statistics', url: `${siteUrl}/grades/ap-statistics` },
    ],
  };

  const grades = [
    {
      id: 'kindergarten',
      path: '/grades/kindergarten',
      grade: 'K',
      title: 'Kindergarten',
      topics: ['Counting & Numbers', 'Basic Shapes', 'Patterns', 'Measurement Basics'],
      color: 'from-pink-500 to-rose-500',
      image: 'https://public.readdy.ai/ai/img_res/c20aa825181eff3fee3dfddcdf62e457.jpg'
    },
    {
      id: 'grade-1',
      path: '/grades/grade-1',
      grade: '1',
      title: 'Grade 1',
      topics: ['Addition & Subtraction', 'Place Value', 'Time & Money', 'Basic Geometry'],
      color: 'from-red-500 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=First%20grade%20mathematics%20materials%20with%20addition%20and%20subtraction%20worksheets%20colorful%20manipulatives%20and%20number%20cards%20on%20a%20clean%20white%20desk%20with%20engaging%20educational%20atmosphere%20showing%20foundational%20arithmetic%20skills&width=600&height=400&seq=grade-1-hub-001&orientation=landscape'
    },
    {
      id: 'grade-2',
      path: '/grades/grade-2',
      grade: '2',
      title: 'Grade 2',
      topics: ['Multi-digit Addition', 'Place Value to 1000', 'Measurement', 'Data & Graphs'],
      color: 'from-orange-500 to-amber-500',
      image: 'https://readdy.ai/api/search-image?query=Second%20grade%20mathematics%20workspace%20with%20place%20value%20charts%20measurement%20tools%20and%20colorful%20graphs%20on%20a%20clean%20white%20surface%20with%20organized%20educational%20materials%20showing%20intermediate%20arithmetic%20concepts&width=600&height=400&seq=grade-2-hub-001&orientation=landscape'
    },
    {
      id: 'grade-3',
      path: '/grades/grade-3',
      grade: '3',
      title: 'Grade 3',
      topics: ['Multiplication & Division', 'Fractions', 'Area & Perimeter', 'Problem Solving'],
      color: 'from-amber-500 to-yellow-500',
      image: 'https://readdy.ai/api/search-image?query=Third%20grade%20mathematics%20learning%20materials%20with%20multiplication%20tables%20fraction%20models%20and%20geometric%20shapes%20on%20a%20clean%20white%20background%20with%20structured%20educational%20atmosphere%20showing%20core%20mathematical%20operations&width=600&height=400&seq=grade-3-hub-001&orientation=landscape'
    },
    {
      id: 'grade-4',
      path: '/grades/grade-4',
      grade: '4',
      title: 'Grade 4',
      topics: ['Multi-digit Operations', 'Equivalent Fractions', 'Decimals', 'Angles & Lines'],
      color: 'from-yellow-500 to-lime-500',
      image: 'https://readdy.ai/api/search-image?query=Fourth%20grade%20mathematics%20study%20area%20with%20decimal%20charts%20fraction%20equivalents%20and%20geometric%20angle%20tools%20on%20a%20clean%20white%20desk%20with%20advanced%20educational%20materials%20showing%20intermediate%20mathematical%20concepts&width=600&height=400&seq=grade-4-hub-001&orientation=landscape'
    },
    {
      id: 'grade-5',
      path: '/grades/grade-5',
      grade: '5',
      title: 'Grade 5',
      topics: ['Fraction Operations', 'Decimal Operations', 'Volume', 'Coordinate Plane'],
      color: 'from-lime-500 to-green-500',
      image: 'https://readdy.ai/api/search-image?query=Fifth%20grade%20mathematics%20workspace%20with%20coordinate%20grids%20volume%20models%20and%20advanced%20fraction%20materials%20on%20a%20clean%20white%20surface%20with%20comprehensive%20educational%20tools%20showing%20upper%20elementary%20mathematics&width=600&height=400&seq=grade-5-hub-001&orientation=landscape'
    },
    {
      id: 'grade-6',
      path: '/grades/grade-6',
      grade: '6',
      title: 'Grade 6',
      topics: ['Ratios & Proportions', 'Expressions & Equations', 'Statistics', 'Geometry'],
      color: 'from-green-500 to-emerald-500',
      image: 'https://readdy.ai/api/search-image?query=Sixth%20grade%20mathematics%20study%20materials%20with%20algebraic%20expressions%20ratio%20tables%20and%20statistical%20graphs%20on%20a%20clean%20white%20background%20with%20middle%20school%20educational%20atmosphere%20showing%20pre-algebra%20foundations&width=600&height=400&seq=grade-6-hub-001&orientation=landscape'
    },
    {
      id: 'grade-7',
      path: '/grades/grade-7',
      grade: '7',
      title: 'Grade 7',
      topics: ['Proportional Relationships', 'Integers', 'Probability', 'Geometric Constructions'],
      color: 'from-emerald-500 to-teal-500',
      image: 'https://readdy.ai/api/search-image?query=Seventh%20grade%20mathematics%20learning%20area%20with%20integer%20number%20lines%20probability%20models%20and%20geometric%20construction%20tools%20on%20a%20clean%20white%20desk%20with%20middle%20school%20educational%20materials%20showing%20advanced%20pre-algebra%20concepts&width=600&height=400&seq=grade-7-hub-001&orientation=landscape'
    },
    {
      id: 'grade-8',
      path: '/grades/grade-8',
      grade: '8',
      title: 'Grade 8',
      topics: ['Linear Equations', 'Functions', 'Pythagorean Theorem', 'Scientific Notation'],
      color: 'from-teal-500 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Eighth%20grade%20mathematics%20workspace%20with%20linear%20function%20graphs%20pythagorean%20theorem%20diagrams%20and%20scientific%20notation%20examples%20on%20a%20clean%20white%20surface%20with%20advanced%20middle%20school%20materials%20showing%20algebra%20readiness&width=600&height=400&seq=grade-8-hub-001&orientation=landscape'
    },
    {
      id: 'grade-9',
      path: '/grades/grade-9',
      grade: '9',
      title: 'Grade 9',
      topics: ['Algebra I', 'Introduction to Geometry', 'Functions & Relations', 'Data Analysis'],
      color: 'from-cyan-500 to-sky-500',
      image: 'https://readdy.ai/api/search-image?query=Ninth%20grade%20high%20school%20mathematics%20materials%20with%20algebra%20textbooks%20geometric%20proofs%20and%20function%20graphs%20on%20a%20clean%20white%20desk%20with%20professional%20educational%20atmosphere%20showing%20freshman%20year%20mathematics&width=600&height=400&seq=grade-9-hub-001&orientation=landscape'
    },
    {
      id: 'grade-10',
      path: '/grades/grade-10',
      grade: '10',
      title: 'Grade 10',
      topics: ['Geometry', 'Algebra II', 'Trigonometry Foundations', 'Advanced Functions'],
      color: 'from-sky-500 to-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=Tenth%20grade%20high%20school%20mathematics%20study%20area%20with%20geometry%20textbooks%20trigonometry%20unit%20circle%20and%20polynomial%20function%20graphs%20on%20a%20clean%20white%20surface%20with%20advanced%20educational%20materials%20showing%20sophomore%20year%20mathematics&width=600&height=400&seq=grade-10-hub-001&orientation=landscape'
    },
    {
      id: 'grade-11',
      path: '/grades/grade-11',
      grade: '11',
      title: 'Grade 11',
      topics: ['Pre-Calculus', 'Trigonometry', 'SAT/ACT Prep', 'Advanced Problem Solving'],
      color: 'from-indigo-500 to-violet-500',
      image: 'https://readdy.ai/api/search-image?query=Eleventh%20grade%20high%20school%20mathematics%20workspace%20with%20pre-calculus%20textbooks%20SAT%20prep%20materials%20and%20trigonometric%20identities%20on%20a%20clean%20white%20desk%20with%20college%20prep%20educational%20atmosphere%20showing%20junior%20year%20mathematics&width=600&height=400&seq=grade-11-hub-001&orientation=landscape'
    },
    {
      id: 'grade-12',
      path: '/grades/grade-12',
      grade: '12',
      title: 'Grade 12',
      topics: ['Calculus', 'Advanced Statistics', 'College Prep Math', 'AP Exam Preparation'],
      color: 'from-violet-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=Twelfth%20grade%20high%20school%20mathematics%20study%20materials%20with%20calculus%20textbooks%20AP%20exam%20prep%20guides%20and%20advanced%20statistics%20on%20a%20clean%20white%20surface%20with%20college-level%20educational%20atmosphere%20showing%20senior%20year%20mathematics&width=600&height=400&seq=grade-12-hub-001&orientation=landscape'
    }
  ];

  const handleGradeClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="K-12 Math Curriculum New York | Choose Your Grade | Augustine Anyimadu-Ahenkae"
        description="Browse comprehensive K-12 mathematics curriculum by grade level. Kindergarten through Grade 12, AP Calculus AB & BC, AP Statistics, and Precalculus — all aligned with Common Core, NYS, and National Standards."
        canonical="/grades"
        keywords="K-12 math curriculum, grade level math lessons, New York math education, AP Calculus, AP Statistics, Precalculus, Common Core math"
        jsonLd={jsonLd}
      />
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-emerald-50 to-teal-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-3 bg-white px-6 py-3 rounded-full shadow-md mb-8">
            <i className="ri-book-open-line text-3xl text-emerald-600"></i>
            <span className="text-lg font-semibold text-gray-800">Complete K-12 Mathematics Curriculum</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 text-gray-900 leading-tight">
            Choose Your Grade Level
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-8">
            Comprehensive mathematics instruction aligned with Common Core, State, and National Standards. 
            Each grade level includes video lessons, digital textbooks, downloadable worksheets, and personalized support.
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-lg text-gray-700">
            <div className="flex items-center gap-2">
              <i className="ri-video-line text-2xl text-emerald-600"></i>
              <span>HD Video Lessons</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-book-2-line text-2xl text-emerald-600"></i>
              <span>Digital Textbooks</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-file-download-line text-2xl text-emerald-600"></i>
              <span>Printable Worksheets</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-question-answer-line text-2xl text-emerald-600"></i>
              <span>Q&A Support</span>
            </div>
          </div>
        </div>
      </section>

      {/* Grades Grid */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          {/* Elementary School */}
          <div className="mb-20">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-pink-500 to-orange-500 rounded-xl">
                <i className="ri-seedling-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900">Elementary School</h2>
                <p className="text-lg text-gray-600">Kindergarten - Grade 5</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {grades.slice(0, 6).map((grade) => (
                <div
                  key={grade.id}
                  onClick={() => handleGradeClick(grade.path)}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:scale-105 bg-white"
                >
                  {/* Image */}
                  <div className="w-full h-56">
                    <img
                      src={grade.image}
                      alt={grade.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>

                  {/* Gradient Overlay on Image */}
                  <div className={`absolute top-0 left-0 right-0 h-56 bg-gradient-to-br ${grade.color} opacity-60 group-hover:opacity-70 transition-opacity duration-500`}></div>

                  {/* Grade Badge */}
                  <div className={`absolute top-6 left-6 w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-lg`}>
                    <span className="text-3xl font-bold text-gray-900">{grade.grade}</span>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{grade.title}</h3>
                    <ul className="space-y-2 mb-6">
                      {grade.topics.map((topic, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-gray-700">
                          <i className="ri-checkbox-circle-fill text-emerald-600 text-lg mt-0.5 flex-shrink-0"></i>
                          <span className="text-sm">{topic}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="flex items-center gap-2 text-emerald-600 font-semibold group-hover:gap-4 transition-all duration-300">
                      <span>Explore Grade {grade.grade}</span>
                      <i className="ri-arrow-right-line text-xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Middle School */}
          <div className="mb-20">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-500 to-teal-500 rounded-xl">
                <i className="ri-plant-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900">Middle School</h2>
                <p className="text-lg text-gray-600">Grades 6 - 8</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {grades.slice(6, 9).map((grade) => (
                <div
                  key={grade.id}
                  onClick={() => handleGradeClick(grade.path)}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:scale-105 bg-white"
                >
                  {/* Image */}
                  <div className="w-full h-56">
                    <img
                      src={grade.image}
                      alt={grade.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>

                  {/* Gradient Overlay on Image */}
                  <div className={`absolute top-0 left-0 right-0 h-56 bg-gradient-to-br ${grade.color} opacity-60 group-hover:opacity-70 transition-opacity duration-500`}></div>

                  {/* Grade Badge */}
                  <div className={`absolute top-6 left-6 w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-lg`}>
                    <span className="text-3xl font-bold text-gray-900">{grade.grade}</span>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{grade.title}</h3>
                    <ul className="space-y-2 mb-6">
                      {grade.topics.map((topic, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-gray-700">
                          <i className="ri-checkbox-circle-fill text-emerald-600 text-lg mt-0.5 flex-shrink-0"></i>
                          <span className="text-sm">{topic}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="flex items-center gap-2 text-emerald-600 font-semibold group-hover:gap-4 transition-all duration-300">
                      <span>Explore Grade {grade.grade}</span>
                      <i className="ri-arrow-right-line text-xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* High School */}
          <div>
            <div className="flex items-center gap-4 mb-10">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-purple-500 rounded-xl">
                <i className="ri-graduation-cap-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900">High School</h2>
                <p className="text-lg text-gray-600">Grades 9 - 12</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {grades.slice(9, 13).map((grade) => (
                <div
                  key={grade.id}
                  onClick={() => handleGradeClick(grade.path)}
                  className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:scale-105 bg-white"
                >
                  {/* Image */}
                  <div className="w-full h-56">
                    <img
                      src={grade.image}
                      alt={grade.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>

                  {/* Gradient Overlay on Image */}
                  <div className={`absolute top-0 left-0 right-0 h-56 bg-gradient-to-br ${grade.color} opacity-60 group-hover:opacity-70 transition-opacity duration-500`}></div>

                  {/* Grade Badge */}
                  <div className={`absolute top-6 left-6 w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-lg`}>
                    <span className="text-3xl font-bold text-gray-900">{grade.grade}</span>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{grade.title}</h3>
                    <ul className="space-y-2 mb-6">
                      {grade.topics.map((topic, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-gray-700">
                          <i className="ri-checkbox-circle-fill text-emerald-600 text-lg mt-0.5 flex-shrink-0"></i>
                          <span className="text-sm">{topic}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="flex items-center gap-2 text-emerald-600 font-semibold group-hover:gap-4 transition-all duration-300">
                      <span>Explore Grade {grade.grade}</span>
                      <i className="ri-arrow-right-line text-xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Advanced Placement Courses */}
          <div className="mt-20">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl">
                <i className="ri-function-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900">Advanced Placement Calculus</h2>
                <p className="text-lg text-gray-600">College-Level Mathematics | AP Exam Preparation</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* AP Calculus AB */}
              <div
                onClick={() => handleGradeClick('/grades/ap-calculus-ab')}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:scale-105 bg-white"
              >
                {/* Image */}
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Advanced%20AP%20Calculus%20mathematics%20textbook%20with%20limit%20derivative%20and%20integral%20notation%20formulas%20on%20a%20clean%20white%20desk%20with%20professional%20college-level%20educational%20materials%20showing%20calculus%20foundations&width=600&height=400&seq=ap-calc-ab-hub-001&orientation=landscape"
                    alt="AP Calculus AB"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>

                {/* Gradient Overlay */}
                <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-br from-blue-600 to-indigo-600 opacity-60 group-hover:opacity-70 transition-opacity duration-500"></div>

                {/* AP Badge */}
                <div className="absolute top-6 left-6 px-4 py-2 bg-white rounded-lg shadow-lg">
                  <span className="text-2xl font-bold text-blue-600">AP</span>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">AP Calculus AB</h3>
                  <p className="text-gray-600 mb-4">First semester college calculus • Equivalent to Calculus I</p>
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-fill text-blue-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Limits and Continuity</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-fill text-blue-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Differentiation: Definition & Applications</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-fill text-blue-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Integration and Accumulation</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-fill text-blue-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Differential Equations & Applications</span>
                    </li>
                  </ul>
                  <div className="flex items-center gap-2 text-blue-600 font-semibold group-hover:gap-4 transition-all duration-300">
                    <span>Start AP Calculus AB</span>
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </div>
              </div>

              {/* AP Calculus BC */}
              <div
                onClick={() => handleGradeClick('/grades/ap-calculus-bc')}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer hover:scale-105 bg-white"
              >
                {/* Image */}
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Advanced%20AP%20Calculus%20BC%20mathematics%20with%20series%20convergence%20tests%20polar%20coordinates%20parametric%20equations%20and%20advanced%20integration%20techniques%20on%20a%20clean%20white%20desk%20with%20college-level%20materials%20showing%20advanced%20calculus%20topics&width=600&height=400&seq=ap-calc-bc-hub-001&orientation=landscape"
                    alt="AP Calculus BC"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>

                {/* Gradient Overlay */}
                <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-br from-purple-600 to-indigo-600 opacity-60 group-hover:opacity-70 transition-opacity duration-500"></div>

                {/* AP Badge with BC */}
                <div className="absolute top-6 left-6 px-4 py-2 bg-white rounded-lg shadow-lg">
                  <span className="text-2xl font-bold text-purple-600">AP BC</span>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">AP Calculus BC</h3>
                  <p className="text-gray-600 mb-4">Full year college calculus • Includes all AB + advanced topics</p>
                  <ul className="space-y-2 mb-6">
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-checkbox-circle-fill text-purple-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">All AP Calculus AB Content</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-star-fill text-purple-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Parametric & Polar Equations</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-star-fill text-purple-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Vector-Valued Functions</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700">
                      <i className="ri-star-fill text-purple-600 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm">Infinite Sequences & Series</span>
                    </li>
                  </ul>
                  <div className="flex items-center gap-2 text-purple-600 font-semibold group-hover:gap-4 transition-all duration-300">
                    <span>Start AP Calculus BC</span>
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-emerald-600 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Get Lifetime Access to Any Grade Level
          </h2>
          <p className="text-xl mb-10 leading-relaxed opacity-95">
            One-time payment. Lifetime access. All materials included. Start mastering mathematics today with 30+ years of proven teaching excellence.
          </p>
          <button
            onClick={() => navigate('/#membership-tiers')}
            className="px-10 py-5 bg-white text-emerald-600 rounded-full text-lg font-bold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            View Membership Options
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}